<template>
    <div class="app flex-row align-items-center">
        <div class="container">
              <div class="row justify-content-center">
                  <div class="col-md-6">
                      <div class="clearfix">
                          <h1 class="float-left display-3 mr-4">404</h1>
                          <h4 class="pt-3">Oeps!</h4>
                          <p class="text-muted">We kunnen de pagina die je zoekt niet vinden.</p>
                      </div>
                      <div>&nbsp;</div>
                      <div class="input-prepend input-group justify-content-center">
                          <span class="input-group-addon"><i class="fa fa-home"></i></span>
                          <span class="input-group-btn">
                              <button class="btn btn-info" type="button" @click="nrhome">Naar home</button>
                          </span>
                      </div>
                  </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Page404',
    methods: {
        nrhome () {
            this.$router.replace('/home');
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/pages/Page404.vue